import React, { useEffect } from 'react';
import './AdmissionPage.scss'; // Admission Page SCSS
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../../components/ActivePath/Header';

const AdmissionPage: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="admission-page">
      {/* Header Section */}
      <Header pageTitle="" breadcrumb="Admission" />
      
      {/* Content Section */}
      <div className="content">
        <div className="content-wrapper" data-aos="fade-up">
          <h2>Admission Procedure</h2>
          <p>
            The institute offers a 3-year diploma in Electronics and Communication Engineering.
          </p>
          <h3>Eligibility</h3>
          <h4>For First Year Admission</h4>
    <ul>
      <li>SSLC / 10th Standard - Pass</li>
      <li>P.U.C - Fail</li>
    </ul>

    <h4>For Lateral Entry Admission (Direct Second Year)</h4>
    <ul>
      <li>P.U.C - Pass</li>
      <li>I.T.I - Pass in relevant branch</li>
      <li>Any other equivalent courses recognized by the Government of Karnataka.</li>
    </ul>
          <p>
            All eligible candidates may apply to the college by filling out the application form available in the College Office.
          </p>
          <p>
            Admission is purely based on a first-come, first-serve basis.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdmissionPage;
